<template>
  <b-card
    title="مدیریت نوع های سند بخشنامه"
  >
    <b-row>

      <b-col
        class="table-size"
      >
        <div class="custom-search">
          <b-row>
            <div class="filter-row">
              <b-button
                class="mb-1 mr-auto ml-1"
                variant="primary"
                @click="addCircularDocumentType()"
              >
                جدید
              </b-button>
              <b-col md="2">
                <b-form-group
                  label="عنوان"
                  label-for="Title"
                >
                  <b-form-input
                    v-model="filterOptions.Title"
                    @keyup.enter="update(1)"
                  />
                </b-form-group>
              </b-col>
              <b-col md="2">
                <b-form-group
                  label="نوع سند والد"
                  label-for="CircularDocumentTypeId"
                >
                  <z-circular-document-type
                    v-model="filterOptions.CircularDocumentTypeId"
                    :clearable="true"
                  />
                </b-form-group>
              </b-col>
              <b-col md="2">
                <b-form-group
                  label="وضعیت"
                  label-for="IsActive"
                >
                  <v-select
                    v-model="filterOptions.IsActive"
                    :options="enums('IsActive')"
                    dir="rtl"
                    label="text"
                    :reduce="x => x.value"
                  />
                </b-form-group>
              </b-col>
              <b-button
                v-ripple.400="'rgba(186, 191, 199, 0.15)'"
                class="mb-1 mr-1"
                variant="warning"
                @click="update(1)"
              >فیلتر
              </b-button>
            </div>
          </b-row>
        </div>

        <b-table
          bordered
          hover
          striped
          :items="items"
          :fields="fields"
          class="mt-1 mb-2 position-relative"
          responsive
          :busy="loading"
        >
          <template #cell(Id)="data">
            <b-link
              class="font-weight-bold"
              @click="updateCircularDocumentType(data.item)"
            >
              #{{ data.value }}
            </b-link>
          </template>

          <template #cell(Title)="data">
            <span class="text-nowrap">
              <b-avatar
                class="mr-50"
                :src="data.item.Image"
              >
                <feather-icon
                  v-if="data.item.Image == null"
                  icon="ImageIcon"
                />
              </b-avatar>

              {{ data.value }}
            </span>
          </template>

          <template #cell(Parent)="data">
            <b-badge
              v-if="data.value"
              variant="info"
            >
              {{ data.value.Title }}
            </b-badge>
          </template>

          <template #cell(IsActive)="data">
            <b-badge
              :variant="data.value ? 'success' : 'warning'"
            >
              {{ data.value ? 'فعال' : 'غیرفعال' }}
            </b-badge>
          </template>

          <template #cell(actions)="data">

            <div
              class="text-nowrap"
            >
              <b-link @click="updateCircularDocumentType(data.item)">
                <feather-icon
                  :id="`invoice-row-${data.item.Id}-send-icon`"
                  icon="EditIcon"
                  size="16"
                />
              </b-link>

              <feather-icon
                icon="TrashIcon"
                size="16"
                class="ml-1 cursor-pointer"
                @click="remove(data.item.Id)"
              />
            </div>
          </template>

          <template #table-busy>
            <div
              class="text-center my-2"
            >
              <b-spinner
                variant="primary"
                class="align-middle"
              />
              <strong class="ml-1">در حال دریافت اطلاعات ...</strong>
            </div>
          </template>

          <template #table-busy>
            <div
              class="text-center my-2"
            >
              <b-spinner
                variant="primary"
                class="align-middle"
              />
              <strong class="ml-1">در حال دریافت اطلاعات ...</strong>
            </div>
          </template>

        </b-table>

        <z-pagination
          :page="filterOptions.Page"
          :per-page.sync="filterOptions.PerPage"
          :total-rows="totalRows"
          :loading="loading"
          @change="update"
        />

      </b-col>

    </b-row>

    <b-modal
      v-if="showCircularDocumentTypeModal"
      v-model="showCircularDocumentTypeModal"
      ok-title="ذخیره"
      cancel-title="انصراف"
      cancel-variant="outline-secondary"
      centered
      title="جزئیات"
      :no-close-on-backdrop="true"
      size="md"
      @ok="save"
    >
      <b-row>

        <div class="responsive-upload">
          <div>
            <input
              ref="refGalley1"
              type="file"
              class="d-none is-primary"
              accept="image/*"
              @change="imageRenderer($event)"
            >

            <div class="px-1">
              <label style="font-weight: 600; display: block">تصویر</label>
              <div
                class="order-upload"
                @click="$refs.refGalley1.click()"
              >
                <img
                  v-if="row.Image"
                  :src="row.Image"
                >
                <div
                  v-else
                  class="activity-upload-video-icon"
                >
                  <feather-icon
                    size="24"
                    icon="UploadIcon"
                  />
                </div>
              </div>
            </div>
          </div>
          <div style="display: flex; flex-wrap: wrap;">

            <b-col md="12">
              <b-form-group
                label="عنوان"
                label-for="Title"
              >
                <b-form-input
                  v-model="row.Title"
                  autocomplete="off"
                />
              </b-form-group>
            </b-col>

            <b-col md="6">
              <b-form-group
                label="وضعیت"
                label-for="IsActive"
              >
                <v-select
                  v-model="row.IsActive"
                  :options="enums('IsActive')"
                  dir="rtl"
                  label="text"
                  :clearable="false"
                  :reduce="x => x.value"
                />
              </b-form-group>
            </b-col>

            <b-col md="6">
              <b-form-group
                label="نوع سند والد"
                label-for="CircularDocumentTypeId"
              >
                <z-circular-document-type
                  v-model="row.CircularDocumentTypeId"
                  :clearable="true"
                />
              </b-form-group>
            </b-col>

            <b-col md="6">
              <b-form-group
                label="ترتیب"
                label-for="Sort"
              >
                <b-form-input
                  v-model.number="row.Sort"
                  type="number"
                  autocomplete="off"
                />
              </b-form-group>
            </b-col>

          </div>
        </div>

        <b-col md="12">
          <b-form-group
            label="توضیحات"
            label-for="Description"
          >
            <b-form-textarea
              v-model="row.Description"
              rows="3"
              no-resize
            />
          </b-form-group>
        </b-col>
      </b-row>
    </b-modal>
  </b-card>
</template>

<script>

import ZCircularDocumentType from '@/tools/circulardocumenttype.vue'

export default {
  name: 'CircularDocumentType',
  components: { ZCircularDocumentType },
  data() {
    return {
      totalRows: 1000 * 1000,
      loading: false,
      filterOptions: {
        Title: null,
        Page: 1,
        PerPage: 10,
      },
      showCircularDocumentTypeModal: false,
      row: {},
      fields: [
        {
          key: 'Id',
          label: '#',
          thClass: 'col-width-50',
        },
        {
          key: 'Title',
          label: 'عنوان',
        },
        {
          key: 'Parent',
          label: 'دسته بندی والد',
        },
        {
          key: 'Sort',
          label: 'ترتیب',
        },
        {
          key: 'IsActive',
          label: 'وضعیت',
        },
        {
          key: 'actions',
          label: '',
          thClass: 'col-width-50',
        },
      ],
      items: [],
    }
  },
  computed: {},
  created() {
    if (this.$store.state.zirehState.listFilter[this.$options.name]) {
      this.filterOptions = this.$store.state.zirehState.listFilter[this.$options.name]
    }
    this.update()
  },
  methods: {
    update(pageNumber) {
      this.loading = true

      this.filterOptions.Page = pageNumber || this.filterOptions.Page

      this.$store.commit('zirehState/setListFilter', { key: this.$options.name, value: this.filterOptions })

      this.$http.post(
        this.$api.circulardocumenttype.getlist, this.filterOptions,
      )
        .then(res => {
          this.totalRows = res.totalRow
          this.items = res.data
        })
        .finally(() => {
          this.loading = false
        })
    },
    save() {
      let url = this.$api.circulardocumenttype.add
      if (this.row.Id) {
        url = this.$api.circulardocumenttype.update
      }

      const formData = new FormData()

      formData.append('Id', this.row.Id)
      formData.append('Title', this.row.Title)
      formData.append('Sort', this.row.Sort || 0)
      formData.append('IsActive', this.row.IsActive)

      if (this.row.CircularDocumentTypeId) {
        formData.append('CircularDocumentTypeId', this.row.CircularDocumentTypeId)
      }

      if (this.row.Description) {
        formData.append('Description', this.row.Description)
      }

      const image = this.$refs.refGalley1.files[0]

      if (image) {
        formData.append('Image', image)
      }

      this.$http.post(
        url, formData,
      )
        .then(() => {
          this.update()
        })
        .catch(() => {
          this.showCircularDocumentTypeModal = true
        })
    },
    addCircularDocumentType() {
      this.row = {
        Title: null, Description: null, Sort: 0, IsActive: true, CircularDocumentTypeId: null, Image: null,
      }
      this.showCircularDocumentTypeModal = true
    },
    updateCircularDocumentType(row) {
      this.row = JSON.parse(JSON.stringify(row))

      if (this.row.Parent) {
        this.row.CircularDocumentTypeId = this.row.Parent.Id
      }

      this.showCircularDocumentTypeModal = true
    },
    remove(id) {
      this.removeRow(this.$api.circulardocumenttype.remove, 'Id', id)
    },
    imageRenderer(event) {
      const fileReader = new FileReader()
      fileReader.readAsDataURL(event.target.files[0])

      fileReader.onload = () => {
        this.row.Image = fileReader.result
      }
    },
  },
}
</script>

<style>

.order-upload {
  align-items: center;
  display: flex;
  height: 112px;
  justify-content: center;
  margin: 0;
  width: 112px;
  text-align: center;
  border: 1px solid #dbdade;
  cursor: pointer;
  border-radius: 0.357rem;
  flex-direction: column;
  margin-bottom: 1rem;
}

@media (min-width: 768px) {
  .responsive-upload{
    width: 100%; display: flex;
  }
}

.order-upload img{
  width: 100%;
  height: 100%;
  object-fit: cover;
  border-radius: 0.357rem;
}

</style>
